import {UserMessageType} from '../type';
import styles from './UserMessage.module.scss';

const UserMessage = ({text, date}: UserMessageType) => {
  return (
    <div className={styles.UserMessageArea}>
      <p>{text}</p>
      <span className={styles.date}>{date}</span>
    </div>
  );
};

export default UserMessage;
